
/** 残高種別コード */
export enum BalanceType {
  // 0:支払
  PAY = '0',
  // 1:買掛
  ACCPAY = '1',
  // 2:請求
  BILLING = '2',
  // 3:売掛
  ACCREC = '3'
}



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/debt-export-condition-modal/debt-export-condition-modal.define.ts